import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import help from '../../assets/SupportTicket/help.svg';

const useStyles = makeStyles((theme) => ({
 
  supportButton: {
    position: 'fixed',
    borderRadius: 30,
    padding: '10px',
    fontWeight: 600,
    fontSize: 16,
    color: '#fff',
    zIndex: '42424242',
    width: 112,
    height: 40,
    backgroundColor: '#254561',
    right: 20,
    bottom: 42,
    cursor: 'pointer',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
        right: 30
    },
  },
  support: {
    paddingLeft: '3px',
    [theme.breakpoints.down('sm')]: {
        paddingLeft: '0px'
    },
  }

}));
 
export const CustomSupport = () => {

  const classes = useStyles();
  const history = useHistory();

  const routeTo = () => {
    history.push('/SupportTicket')
    window.location.reload();
  }

return (
    <>
    <span className={classes.supportButton} onClick={() => routeTo()}>
        <img src={help} alt="support ticket"/>
        <span className={classes.support}>Support</span>
    </span> 
    </> 
);
};
 